import { render, staticRenderFns } from "./DiscussionDelete.vue?vue&type=template&id=3f3d83f8&"
import script from "./DiscussionDelete.vue?vue&type=script&lang=js&"
export * from "./DiscussionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports